import API, { AUTH_HEADER, GET_AUTH } from 'base/api';
import { fetchAllRooms } from './getRooms';

export const ADD_ROOM = 'ADD_ROOM';
export const ADD_ROOM_BEGIN = 'ADD_ROOM_BEGIN';
export const ADD_ROOM_SUCCESS = 'ADD_ROOM_SUCCESS';
export const ADD_ROOM_ERROR = 'ADD_ROOM_ERROR';

export const addRoomBegin = () => ({
  type: ADD_ROOM_BEGIN
});

export const addRoomSuccess = ( data ) => ({
  type: ADD_ROOM_SUCCESS,
  payload: { data }
});

export const addRoomError = ( error ) => ({
  type: ADD_ROOM_ERROR,
  payload: { error }
});

export function addRoom (data){
  return dispatch => {
    dispatch(addRoomBegin());
    return fetch(API.ADD_ROOM, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: new Headers(AUTH_HEADER)
    })
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(addRoomSuccess(json));
        dispatch(fetchAllRooms(json));
        console.log(json)
        return json;
      })
      .catch(error => dispatch(addRoomError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/addRoom.js